@if (kind === 'integration') {
<p
  class="gallery-badge"
  [class.tone-on-dark]="tone === 'onDark'"
  [class.align-start]="align === 'start'"
  data-testid="official-integration-badge">
  <img
    src="assets/images/notion_icon.webp"
    alt=""
    aria-hidden="true"
    width="18"
    height="18"
    class="gallery-badge-icon"
  />
  <span
    >Official Notion integration &middot;
    <a
      class="text-link"
      href="https://www.notion.com/connections/nh2"
      target="_blank"
      rel="noopener"
      data-testid="official-integration-badge-link"
      >listed in Notion's integration gallery</a
    ></span
  >
</p>
} @else {
<p
  class="gallery-badge"
  [class.tone-on-dark]="tone === 'onDark'"
  [class.align-start]="align === 'start'"
  data-testid="official-template-badge">
  <img
    src="assets/images/notion_icon.webp"
    alt=""
    aria-hidden="true"
    width="18"
    height="18"
    class="gallery-badge-icon"
  />
  <span
    >Free Notion template &middot;
    <a
      class="text-link"
      [href]="templateGalleryUrl"
      target="_blank"
      rel="noopener"
      data-testid="official-template-badge-link"
      >listed in Notion's template gallery</a
    ></span
  >
</p>
}
